import type { LucideProps } from "@fleet/icons";
import type { Component } from "solid-js";
import {
  Armchair,
  Award,
  Baby,
  BedDouble,
  BookOpen,
  Briefcase,
  Bus,
  Car,
  CarTaxiFront,
  CircleEllipsis,
  Clapperboard,
  Coffee,
  Cookie,
  CupSoda,
  Droplets,
  Dumbbell,
  FileText,
  Flame,
  Fuel,
  Gamepad2,
  Gift,
  GraduationCap,
  Hammer,
  HandCoins,
  HeartHandshake,
  HeartPulse,
  House,
  Joystick,
  KeyRound,
  Lamp,
  Landmark,
  Laptop,
  Map as MapIcon,
  MonitorPlay,
  Palette,
  PartyPopper,
  PawPrint,
  Percent,
  Phone,
  Pill,
  Plane,
  PlaneTakeoff,
  PlugZap,
  Receipt,
  RotateCcw,
  Sandwich,
  School,
  ShieldPlus,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  Smartphone,
  Smile,
  Sparkles,
  SquareParking,
  Stethoscope,
  TrendingUp,
  TriangleAlert,
  Tv,
  Users,
  Utensils,
  UtensilsCrossed,
  Wifi,
  Wrench,
  Zap,
} from "@fleet/icons";

export type CategoryIcon = Component<LucideProps>;

/** Icons available for categories (kebab-case name stored in DB → component). */
const CATEGORY_ICONS: Record<string, CategoryIcon> = {
  utensils: Utensils,
  coffee: Coffee,
  sandwich: Sandwich,
  "utensils-crossed": UtensilsCrossed,
  cookie: Cookie,
  "cup-soda": CupSoda,
  "shopping-basket": ShoppingBasket,
  car: Car,
  fuel: Fuel,
  bus: Bus,
  "car-taxi-front": CarTaxiFront,
  "square-parking": SquareParking,
  wrench: Wrench,
  "shopping-bag": ShoppingBag,
  shirt: Shirt,
  smartphone: Smartphone,
  lamp: Lamp,
  sparkles: Sparkles,
  "gamepad-2": Gamepad2,
  clapperboard: Clapperboard,
  joystick: Joystick,
  dumbbell: Dumbbell,
  tv: Tv,
  palette: Palette,
  house: House,
  "key-round": KeyRound,
  landmark: Landmark,
  armchair: Armchair,
  hammer: Hammer,
  "plug-zap": PlugZap,
  zap: Zap,
  droplets: Droplets,
  flame: Flame,
  wifi: Wifi,
  phone: Phone,
  "heart-pulse": HeartPulse,
  stethoscope: Stethoscope,
  pill: Pill,
  smile: Smile,
  "shield-plus": ShieldPlus,
  "graduation-cap": GraduationCap,
  school: School,
  "book-open": BookOpen,
  "monitor-play": MonitorPlay,
  plane: Plane,
  "plane-takeoff": PlaneTakeoff,
  "bed-double": BedDouble,
  map: MapIcon,
  users: Users,
  baby: Baby,
  "paw-print": PawPrint,
  "hand-coins": HandCoins,
  gift: Gift,
  "heart-handshake": HeartHandshake,
  "party-popper": PartyPopper,
  receipt: Receipt,
  "file-text": FileText,
  "triangle-alert": TriangleAlert,
  "circle-ellipsis": CircleEllipsis,
  briefcase: Briefcase,
  award: Award,
  "trending-up": TrendingUp,
  percent: Percent,
  "rotate-ccw": RotateCcw,
  laptop: Laptop,
};

export function resolveCategoryIcon(name: string | null | undefined): CategoryIcon {
  return (name && CATEGORY_ICONS[name]) || CircleEllipsis;
}
